<template>
    <div>
        <div style="width: 100%; position: relative;">
            <van-image width="100%" height="108px" fit="cover" :src="require('@/assets/shareBackground.jpg')"/>
            <div style="position: absolute; top: 0; width: 100%; display: flex; flex-direction: column; align-items: center;">
                <van-image round width="50px" height="50px;" :src=" star.imageUrl ? star.imageUrl : require('@/assets/defaultProfile.jpg')"
                           style="margin-top: 11px;"/>
                <div style="margin: 5px 0; font-size: 14px; color: white;">{{star.userName ? star.userName : '暂无'}}</div>
                <div style="color: white; font-size: 12px;">本月推广之星</div>
            </div>
        </div>
        <div style="margin-top: 10px;">
            <div class="shareTitle">我的推广排名</div>
            <div style="display: flex; background-color: white; padding: 18px 20px; margin-top: 1px;">
                <van-image width="50px" round height="50px;" :src="me.imageUrl ? me.imageUrl : require('@/assets/defaultProfile.jpg')"/>
                <div style="flex: 1; margin-left: 10px; display: flex; flex-direction: column; justify-content: center;">
                    <div style="color: #333333; font-size: 14px; margin-bottom: 5px;">{{me.userName}}</div>
                    <div style="color: #FDD668; font-size: 12px; display: flex; align-items: center;">
                        <van-image width="14px" height="14px" :src="require('@/assets/shareFirst.png')"/>
                        <span>{{ me.ranking ? `第${me.ranking}` : '未上榜'}}名</span>
                    </div>
                </div>
                <div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-end;">
                    <div style="color: #333333; font-size: 14px;">{{me.score}}</div>
                    <div style="color: #999999; font-size: 12px; text-align: end;">积分</div>
                </div>
            </div>
            <div @click="moreRank" style="color: #3173C8; font-size: 12px; text-align: center; background-color: white; padding: 10px 0; margin-top: 1px;">
                查看更多排名
            </div>
        </div>
        <div style="margin-top: 10px;">
            <div class="shareTitle">达人经验谈</div>
            <div style="display: flex; flex-direction: column;">
                <van-list v-model="loading" :finished="finished"
                          finished-text="没有更多了" @load="getArticles">
                    <div v-for="(item,index) in articles" :key="index"
                         style="display: flex; justify-content: space-between; margin-top: 1px; padding: 10px 0; background-color: white;"
                         @click="gotoArticleDetail(item)">
                        <div style="flex: 1; margin-left: 20px; display: flex; flex-direction: column; align-items: start;">
                            <div style="color: #333333; font: 14px bold; margin-bottom: 3px;">{{item.newsTitle}}</div>
                            <div style="color: #999999; font-size: 12px; margin-top: 6px;">{{item.newsDate|dateFormat('YYYY年M月D日')}}</div>
                        </div>
                        <van-image :src="item.newsImage" radius="6px" width="92px" height="56" style="margin: 0 20px 0 15px;" />
                    </div>
                </van-list>
            </div>
        </div>

    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image, Button, Cell, List} from 'vant';
    import Cookies from 'js-cookie'
    Vue.use(Image).use(Button).use(Cell).use(List);

    export default {
        name: "Share",
        data() {
            return {
                type: Cookies.get('type'),
                loading: false,
                finished: false,
                articles: [],
                page: 0,
                pageSize: 10,
                star: {},
                me: {}
            }
        },
        created() {
            this.getLoveStar()
            this.getMyRank()
            this.getArticles()
        },
        methods: {
            getLoveStar() {
                this.$axios.get("/integral/ranking",{params: {type: '3'}}).then(res => {
                    if (res.code == 200 && res.data.rows) {
                        this.star = res.data.rows[0]
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
            getMyRank() {
                this.$axios.get("/integral/own",{params: {type:3}}).then(res => {
                    this.me = res.data
                }).catch(err => {
                    console.log(err);
                })
            },
            getArticles() {
                this.page++
                this.loading = true
                this.$axios.get("/article/list", {params: {type: '6', page: this.page, pageSize: this.pageSize, newsBelong: this.type}}).then(res => {
                    this.loading = false;
                    let data = res.data.rows;
                    this.articles = this.articles.concat(data);
                    if(data.length < this.pageSize) {
                        this.finished = true;
                    }
                }).catch(err => {
                    console.log(err);
                    this.loading = false
                })
            },
            gotoArticleDetail(item) {
                if (item.newsUrl.length > 0) {
                    window.location.href = item.newsUrl
                } else {
                    // this.$router.push({path: '/articleDetail', query: {newsId: item.newsId}})
                    window.location.href = `${process.env.VUE_APP_SHARE_URL}/articleDetail?newsId=${item.newsId}`
                }
            },
            moreRank() {
                // this.$router.push('/rank')
                window.location.href = `${process.env.VUE_APP_SHARE_URL}/rank?integral=integral`
            }
        }
    }
</script>

<style scoped>
    .shareTitle {
        background-color: white;
        padding: 8px 20px;
        font-weight: bold;
    }
</style>
